import { render, staticRenderFns } from "./SurveyApprovalCreation.vue?vue&type=template&id=1bb4ca74"
import script from "./SurveyApprovalCreation.vue?vue&type=script&lang=js"
export * from "./SurveyApprovalCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports